import Vue from 'vue'
import Vuex from 'vuex'
import search from './modules/search'
import auth from './modules/auth'
import shortlist from './modules/shortlist'
import messages from './modules/messages'
import compare from './modules/compare'
import watchlist from './modules/watchlist'
import fund from './modules/fund'
import blog from './modules/blog'
import topFundList from './modules/topFundList'


Vue.use(Vuex)

const debug = true

export default new Vuex.Store({
    modules: {
        search,
        auth,
        messages,
        shortlist,
        compare,
        watchlist,
        fund,
        blog,
        topFundList
    },
    strict: debug,
})
